import React from "react";
import { getProfilePhotoUrl } from "../../lib/mediaUrls";

/** Avatar + name + @handle row for an RGM artist profile. */
export const ArtistChip = ({ profile, sub, testId }) => (
  <span className="flex items-center gap-2 min-w-0" data-testid={testId}>
    <img src={getProfilePhotoUrl(profile)} alt="" className="w-8 h-8 shrink-0 rounded-full object-cover border border-white/10" />
    <span className="min-w-0">
      <span className="block text-xs font-semibold text-white truncate">{profile?.name || "RGM Artist"}</span>
      <span className="block text-[10px] text-gray-500 truncate">{profile?.handle ? `@${profile.handle}` : ""}{sub ? ` ${sub}` : ""}</span>
    </span>
  </span>
);

export const STATUS_STYLE = {
  pending: "bg-amber-500/20 text-amber-200",
  accepted: "bg-emerald-500/20 text-emerald-200",
  declined: "bg-red-500/20 text-red-200",
  revoked: "bg-gray-500/20 text-gray-300",
};

export const StatusPill = ({ status, testId }) => (
  <span className={`text-[10px] px-1.5 py-0.5 rounded font-bold capitalize ${STATUS_STYLE[status] || "bg-white/10 text-gray-300"}`} data-testid={testId}>
    {status}
  </span>
);

export default ArtistChip;
